/**
 * Shared configuration for both frontend and backend
 */

// Full location details including coordinates and names
const locations = {
  BANNEKER: {
    id: 1,
    shortName: "BES",
    fullName: "Benjamin Banneker Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.3297214,
      lng: -76.6758535
    }
  },
  DUKE: {
    id: 2,
    shortName: "CWFD",
    fullName: "Captain Walter Francis Duke Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.3144394,
      lng: -76.6363073
    }
  },
  DYNARD: {
    id: 3,
    shortName: "DES",
    fullName: "Dynard Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.3140916,
      lng: -76.7591032
    }
  },
  EVERGREEN: {
    id: 4,
    shortName: "EES",
    fullName: "Evergreen Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.2993082,
      lng: -76.5633583
    }
  },
  CARVER: {
    id: 5,
    shortName: "CES",
    fullName: "George Washington Carver Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.2497056,
      lng: -76.4798641
    }
  },
  GREEN_HOLLY: {
    id: 6,
    shortName: "GHES",
    fullName: "Green Holly Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.2944748,
      lng: -76.4825953
    }
  },
  GREENVIEW: {
    id: 7,
    shortName: "GKES",
    fullName: "Greenview Knolls School Age Center",
    type: "Elementary School",
    coordinates: {
      lat: 38.2800766,
      lng: -76.4930985
    }
  },
  HOLLYWOOD: {
    id: 8,
    shortName: "HES",
    fullName: "Hollywood Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.3373834,
      lng: -76.5421879
    }
  },
  LEONARDTOWN_ELEM: {
    id: 9,
    shortName: "LES",
    fullName: "Leonardtown Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.2967609,
      lng: -76.6392651
    }
  },
  DENT: {
    id: 10,
    shortName: "LDES",
    fullName: "Lettie M Dent Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.4743607,
      lng: -76.7676672
    }
  },
  LEXINGTON_PARK: {
    id: 11,
    shortName: "LPES",
    fullName: "Lexington Park Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.2600484,
      lng: -76.4578451
    }
  },
  MECHANICSVILLE: {
    id: 12,
    shortName: "MES",
    fullName: "Mechanicsville Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.4531739,
      lng: -76.7545612
    }
  },
  OAKVILLE: {
    id: 13,
    shortName: "OES",
    fullName: "Oakville Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.3945035,
      lng: -76.6464347
    }
  },
  PARK_HALL: {
    id: 14,
    shortName: "PHES",
    fullName: "Park Hall Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.2240115,
      lng: -76.4518582
    }
  },
  PINEY_POINT: {
    id: 15,
    shortName: "PPES",
    fullName: "Piney Point Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.1667233,
      lng: -76.5360991
    }
  },
  RIDGE: {
    id: 16,
    shortName: "RES",
    fullName: "Ridge Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.1105587,
      lng: -76.3655162
    }
  },
  TOWN_CREEK: {
    id: 17,
    shortName: "TCES",
    fullName: "Town Creek Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.302936,
      lng: -76.4911319
    }
  },
  WHITE_MARSH: {
    id: 18,
    shortName: "WMES",
    fullName: "White Marsh Elementary",
    type: "Elementary School",
    coordinates: {
      lat: 38.4670458,
      lng: -76.7762817
    }
  },
  MARGARET_BRENT: {
    id: 19,
    shortName: "MBMS",
    fullName: "Margaret Brent Middle",
    type: "Middle School",
    coordinates: {
      lat: 38.3799173,
      lng: -76.7161651
    }
  },
  SPRING_RIDGE: {
    id: 20,
    shortName: "SRMS",
    fullName: "Spring Ridge Middle",
    type: "Middle School",
    coordinates: {
      lat: 38.2122472,
      lng: -76.4012935
    }
  },
  ESPERANZA: {
    id: 21,
    shortName: "EMS",
    fullName: "Esperanza Middle",
    type: "Middle School",
    coordinates: {
      lat: 38.2926091,
      lng: -76.4889685
    }
  },
  LEONARDTOWN_MIDDLE: {
    id: 22,
    shortName: "LMS",
    fullName: "Leonardtown Middle",
    type: "Middle School",
    coordinates: {
      lat: 38.2738933,
      lng: -76.6122046
    }
  },
  CHOPTICON: {
    id: 24,
    shortName: "CHS",
    fullName: "Chopticon High",
    type: "High School",
    coordinates: {
      lat: 38.3595688,
      lng: -76.7063079
    }
  },
  GREAT_MILLS: {
    id: 25,
    shortName: "GMHS",
    fullName: "Great Mills High",
    type: "High School",
    coordinates: {
      lat: 38.2474355,
      lng: -76.4874175
    }
  },
  LEONARDTOWN_HIGH: {
    id: 26,
    shortName: "LHS",
    fullName: "Leonardtown High",
    type: "High School",
    coordinates: {
      lat: 38.2696812,
      lng: -76.61129
    }
  },
  FAIRLEAD: {
    id: 27,
    shortName: "FLA",
    fullName: "Fairlead Academy",
    type: "Academy",
    coordinates: {
      lat: 38.2405204,
      lng: -76.4945314
    }
  },
  STADIUM: {
    id: 35,
    shortName: "STADIUM",
    fullName: "Jamie L. Roberts Stadium",
    type: "Stadium",
    coordinates: {
      lat: 38.186476,
      lng: -76.419364
    }
  }
};

// Canonical town/place name for each ZCTA (zip) used in the dashboard.
const ZIP_TOWN_NAMES = {
  "20609": "Avenue",
  "20619": "California",
  "20634": "Great Mills",
  "20636": "Hollywood",
  "20650": "Leonardtown",
  "20653": "Lexington Park",
  "20659": "Mechanicsville",
  "20680": "Ridge",
  "20690": "Tall Timbers"
};

// Zip code + town/region for each location, keyed by location id.
// Zip codes are assigned by point-in-polygon test against the Census ZCTA
// boundaries in data_maps/zips (the same polygons drawn on the map), so each
// location belongs to the zip whose shape actually contains it.
const locationZipData = {
  1:  { zipCode: "20650" },  // Benjamin Banneker Elementary
  2:  { zipCode: "20650" },  // Captain Walter Francis Duke Elementary
  3:  { zipCode: "20609" },  // Dynard Elementary
  4:  { zipCode: "20619" },  // Evergreen Elementary
  5:  { zipCode: "20653" },  // George Washington Carver Elementary
  6:  { zipCode: "20653" },  // Green Holly Elementary
  7:  { zipCode: "20634" },  // Greenview Knolls School Age Center
  8:  { zipCode: "20636" },  // Hollywood Elementary
  9:  { zipCode: "20650" },  // Leonardtown Elementary
  10: { zipCode: "20659" },  // Lettie M Dent Elementary
  11: { zipCode: "20653" },  // Lexington Park Elementary
  12: { zipCode: "20659" },  // Mechanicsville Elementary
  13: { zipCode: "20659" },  // Oakville Elementary
  14: { zipCode: "20653" },  // Park Hall Elementary
  15: { zipCode: "20690" },  // Piney Point Elementary
  16: { zipCode: "20680" },  // Ridge Elementary
  17: { zipCode: "20653" },  // Town Creek Elementary
  18: { zipCode: "20659" },  // White Marsh Elementary
  19: { zipCode: "20659" },  // Margaret Brent Middle
  20: { zipCode: "20653" },  // Spring Ridge Middle
  21: { zipCode: "20653" },  // Esperanza Middle
  22: { zipCode: "20650" },  // Leonardtown Middle
  24: { zipCode: "20650" },  // Chopticon High
  25: { zipCode: "20653" },  // Great Mills High
  26: { zipCode: "20650" },  // Leonardtown High
  27: { zipCode: "20634" },  // Fairlead Academy
  35: { zipCode: "20653" }   // Jamie L. Roberts Stadium
};

// Fill in the town name for each location from its zip.
Object.values(locationZipData).forEach(entry => {
  entry.town = ZIP_TOWN_NAMES[entry.zipCode] || null;
});

// Helper functions to get different views of the data
const getLocationById = (id) => {
  return Object.values(locations).find(loc => loc.id === parseInt(id));
};

const getLocationByShortName = (shortName) => {
  return Object.values(locations).find(loc => loc.shortName === shortName);
};

// Create a map of ID to location info (for frontend components)
const locationMap = Object.values(locations).reduce((acc, location) => {
  const zipInfo = locationZipData[location.id] || {};
  acc[location.id] = {
    name: location.fullName,  // Changed from shortName to fullName
    shortName: location.shortName,
    fullName: location.fullName,  // Added fullName explicitly
    type: location.type,
    lat: location.coordinates.lat,
    lng: location.coordinates.lng,
    zipCode: zipInfo.zipCode || null,
    town: zipInfo.town || null
  };
  return acc;
}, {});

// Map of zip code -> town name (canonical place name for each zip in use)
const ZIP_TO_TOWN = Object.values(locationZipData).reduce((acc, { zipCode, town }) => {
  if (zipCode) acc[zipCode] = town;
  return acc;
}, {});

// Sorted list of regions for the selector: each town with its zip and how many
// locations fall in it. Towns map 1:1 to zips in the current dataset, but the
// selector treats town (name) and zip (number) as the coarse/fine views.
const getRegions = () => {
  const counts = {};
  Object.values(locationMap).forEach(({ zipCode, town }) => {
    if (!zipCode) return;
    if (!counts[zipCode]) counts[zipCode] = { zipCode, town, count: 0 };
    counts[zipCode].count += 1;
  });
  return Object.values(counts).sort((a, b) => a.town.localeCompare(b.town));
};

// Location ids that match a given filter ({ zipCode } or { town } or {} for all)
const getLocationIdsForRegion = ({ zipCode = null, town = null } = {}) => {
  return Object.entries(locationMap)
    .filter(([, info]) => {
      if (zipCode && info.zipCode !== zipCode) return false;
      if (town && info.town !== town) return false;
      return true;
    })
    .map(([id]) => id);
};

// Map PurpleAir sensor IDs to locations
const sensorMap = {
  92271: { locationId: 10, name: "Lettie M Dent Elementary", position: "Front Sensor" },
  91277: { locationId: 10, name: "Lettie M Dent Elementary", position: "Side Sensor" },
  92885: { locationId: 10, name: "Lettie M Dent Elementary", position: "Back Sensor" },
  92793: { locationId: 16, name: "Ridge Elementary", position: "Left Side Sensor" },
  91809: { locationId: 16, name: "Ridge Elementary", position: "Front Sensor" },
  90635: { locationId: 16, name: "Ridge Elementary", position: "Right Side Sensor" },
  90599: { locationId: 15, name: "Piney Point Elementary", position: "Back Sensor" },
  90655: { locationId: 15, name: "Piney Point Elementary", position: "Right Sensor" },
  92291: { locationId: 15, name: "Piney Point Elementary", position: "Front Sensor" },
  91347: { locationId: 20, name: "Spring Ridge Middle", position: "Right Side Sensor" },
  92789: { locationId: 20, name: "Spring Ridge Middle", position: "Front Sensor" },
  92821: { locationId: 20, name: "Spring Ridge Middle", position: "Back Sensor" },
  92881: { locationId: 14, name: "Park Hall Elementary", position: "Back Right Sensor" },
  91393: { locationId: 14, name: "Park Hall Elementary", position: "Front Left Sensor" },
  92859: { locationId: 14, name: "Park Hall Elementary", position: "Front Right Sensor" },
  93019: { locationId: 5, name: "George Washington Carver Elementary", position: "Back Sensor" },
  90589: { locationId: 5, name: "George Washington Carver Elementary", position: "Right Side Sensor" },
  85659: { locationId: 5, name: "George Washington Carver Elementary", position: "Front Sensor" },
  90817: { locationId: 25, name: "Great Mills High", position: "Front Sensor" },
  92289: { locationId: 27, name: "Fairlead Academy", position: "Front Sensor" },
  93001: { locationId: 27, name: "Fairlead Academy", position: "Back Left Sensor" },
  92285: { locationId: 27, name: "Fairlead Academy", position: "Back Right Sensor" },
  92281: { locationId: 11, name: "Lexington Park Elementary", position: "Back Sensor" },
  90881: { locationId: 11, name: "Lexington Park Elementary", position: "Left Side Sensor" },
  92245: { locationId: 11, name: "Lexington Park Elementary", position: "Front Sensor" },
  90647: { locationId: 7, name: "Greenview Knolls School Age Center", position: "Right Sensor" },
  92559: { locationId: 7, name: "Greenview Knolls School Age Center", position: "Front Sensor" },
  92325: { locationId: 7, name: "Greenview Knolls School Age Center", position: "Left Sensor" },
  92969: { locationId: 21, name: "Esperanza Middle", position: "Front Right Sensor" },
  83993: { locationId: 21, name: "Esperanza Middle", position: "Back Left Sensor" },
  92689: { locationId: 21, name: "Esperanza Middle", position: "Front Left Sensor" },
  90687: { locationId: 6, name: "Green Holly Elementary", position: "Back Sensor" },
  92701: { locationId: 6, name: "Green Holly Elementary", position: "Front Right Sensor" },
  85473: { locationId: 6, name: "Green Holly Elementary", position: "Front Left Sensor" },
  92803: { locationId: 17, name: "Town Creek Elementary", position: "Back Left Sensor" },
  91811: { locationId: 17, name: "Town Creek Elementary", position: "Front Sensor" },
  91819: { locationId: 17, name: "Town Creek Elementary", position: "Front Right Sensor" },
  92437: { locationId: 4, name: "Evergreen Elementary", position: "Front Left Sensor" },
  92427: { locationId: 4, name: "Evergreen Elementary", position: "Front Right Sensor" },
  92833: { locationId: 8, name: "Hollywood Elementary", position: "Front Right Sensor" },
  90849: { locationId: 8, name: "Hollywood Elementary", position: "Back Sensor" },
  85455: { locationId: 8, name: "Hollywood Elementary", position: "Front Left Sensor" },
  92769: { locationId: 26, name: "Leonardtown High", position: "Right Side Sensor" },
  92695: { locationId: 26, name: "Leonardtown High", position: "Front Sensor" },
  92683: { locationId: 26, name: "Leonardtown High", position: "Left Side Sensor" },
  92855: { locationId: 22, name: "Leonardtown Middle", position: "Back Sensor" },
  92415: { locationId: 22, name: "Leonardtown Middle", position: "Front Sensor" },
  93017: { locationId: 22, name: "Leonardtown Middle", position: "Right Side Sensor" },
  90645: { locationId: 9, name: "Leonardtown Elementary", position: "Front Left Sensor" },
  92745: { locationId: 9, name: "Leonardtown Elementary", position: "Front Right Sensor" },
  83855: { locationId: 9, name: "Leonardtown Elementary", position: "Back Sensor" },
  93027: { locationId: 2, name: "Captain Walter Francis Duke Elementary", position: "Front Left Sensor" },
  90659: { locationId: 2, name: "Captain Walter Francis Duke Elementary", position: "Front Right Sensor" },
  93015: { locationId: 1, name: "Benjamin Banneker Elementary", position: "Front Sensor" },
  93025: { locationId: 1, name: "Benjamin Banneker Elementary", position: "Right Side Sensor" },
  93013: { locationId: 1, name: "Benjamin Banneker Elementary", position: "Back Sensor" },
  92421: { locationId: 3, name: "Dynard Elementary", position: "Back Sensor" },
  92425: { locationId: 3, name: "Dynard Elementary", position: "Right Side Sensor" },
  93021: { locationId: 3, name: "Dynard Elementary", position: "Front Sensor" },
  90629: { locationId: 24, name: "Chopticon High", position: "Back Sensor" },
  91329: { locationId: 24, name: "Chopticon High", position: "Front Sensor" },
  90641: { locationId: 24, name: "Chopticon High", position: "Left Side Sensor" },
  92883: { locationId: 19, name: "Margaret Brent Middle", position: "Back Sensor" },
  92827: { locationId: 19, name: "Margaret Brent Middle", position: "Front Sensor" },
  89235: { locationId: 13, name: "Oakville Elementary", position: "Front Right Sensor" },
  92279: { locationId: 13, name: "Oakville Elementary", position: "Back Sensor" },
  92795: { locationId: 13, name: "Oakville Elementary", position: "Front Left Sensor" },
  92679: { locationId: 12, name: "Mechanicsville Elementary", position: "Back Sensor" },
  92999: { locationId: 12, name: "Mechanicsville Elementary", position: "Left Side Sensor" },
  92687: { locationId: 12, name: "Mechanicsville Elementary", position: "Front Sensor" },
  92747: { locationId: 18, name: "White Marsh Elementary", position: "Back Sensor" },
  92785: { locationId: 18, name: "White Marsh Elementary", position: "Left Side" },
  91383: { locationId: 18, name: "White Marsh Elementary", position: "Front Sensor" },
  92807: { locationId: 35, name: "Jamie L. Roberts Stadium", position: "Main Sensor" }
};

module.exports = {
  locations,
  getLocationById,
  getLocationByShortName,
  locationMap,
  sensorMap,
  locationZipData,
  ZIP_TO_TOWN,
  getRegions,
  getLocationIdsForRegion
};